var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('highlight-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "persistent": ""
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "hl-download",
    class: {
      'is-complete': _vm.isComplete,
      'is-error': _vm.isError
    }
  }, [_c('div', {
    staticClass: "hl-download-icon"
  }, [_vm.isError ? _c('svg', {
    staticClass: "hl-download-error",
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  })]) : _vm.isComplete ? _c('svg', {
    staticClass: "hl-download-check",
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
    }
  })]) : _c('svg', {
    staticClass: "hl-download-arrow",
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 3a1 1 0 0 1 1 1v9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.42l3.3 3.3V4a1 1 0 0 1 1-1zm-7 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"
    }
  })]), _c('span', {
    staticClass: "hl-download-ring",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('p', {
    staticClass: "hl-download-title"
  }, [_vm._v(_vm._s(_vm.video.title))]), _c('p', {
    staticClass: "hl-download-status"
  }, [_vm._v(_vm._s(_vm.statusText))]), _c('div', {
    staticClass: "hl-progress",
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('div', {
    staticClass: "hl-progress-bar",
    style: {
      width: _vm.progress + '%'
    }
  })]), _c('div', {
    staticClass: "hl-download-stats"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedBytes))]), _c('span', [_vm._v(_vm._s(_vm.progress) + "%")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }